<section class="features-wrapper">
    <ng-container *ngFor="let group of paginatedGroups">
        <h3 class="group-label">{{ group.groupLabel }}</h3>

        <div class="features-list">
            <div class="feature-item" *ngFor="let feature of group.visible">
                <mat-icon class="feature-icon">radio_button_unchecked</mat-icon>
                <span class="feature-label">{{ feature.featureLabel }}</span>
            </div>
        </div>

        <button
            *ngIf="hasMore(group)"
            (click)="loadMore(group)"
            class="btn-show-more"
        >
            Mostrar más características
            <mat-icon>add</mat-icon>
        </button>
    </ng-container>
</section>
